import React from "react";

export default function LiveIndicator() {
  return (
    <div className="bg-red w-8 h-4 text-white uppercase rounded-sm flex items-center justify-center text-label-medium">
      LIVE
    </div>
  );
}
